import ActiveExperiment from './ActiveExperiment';
import FAQS, { type FaqData } from './faqs';
import RESPONSIVE_DATA from './responsive-data';

export type { FaqData };
export { ActiveExperiment, FAQS, RESPONSIVE_DATA };
